<span class="role-badge role-badge--{{ role }} flex-shrink-1">
  <ng-content></ng-content>
</span>
